import apiClient from "./client";
import { unwrapApiResponse } from "../utils/apiError";
import { BINARY_REQUEST_CONFIG, saveAxiosFile } from "../utils/download";

export const classAPI = {
  getAll: async () => {
    const response = await apiClient.get("/teacher/classes");
    return unwrapApiResponse(response);
  },

  getById: async (id) => {
    const response = await apiClient.get(`/teacher/classes/${id}`);
    return unwrapApiResponse(response);
  },

  updateStudentAttendance: async ({ classId, studentId, date, status, description = "" }) => {
    const response = await apiClient.patch(
      `/teacher/classes/${classId}/students/${studentId}/attendance`,
      { date, status, description }
    );
    return unwrapApiResponse(response);
  },

  getAttendance: async (
    classId,
    { classSubjectId, startDate, endDate, studentId, status } = {}
  ) => {
    const response = await apiClient.get(`/teacher/classes/${classId}/attendance`, {
      params: {
        ...(classSubjectId ? { classSubjectId } : {}),
        startDate,
        endDate,
        ...(studentId ? { studentId } : {}),
        ...(status ? { status } : {}),
      },
    });
    return unwrapApiResponse(response);
  },

  initializeAttendanceDay: async (classId, { classSubjectId, date }) => {
    const response = await apiClient.post(
      `/teacher/classes/${classId}/attendance/initialize-day`,
      { date },
      { params: { classSubjectId } }
    );
    return unwrapApiResponse(response);
  },

  getAttendanceDay: async (classId, { classSubjectId, date }) => {
    const response = await apiClient.get(`/teacher/classes/${classId}/attendance/day`, {
      params: {
        classSubjectId,
        date,
      },
    });
    return unwrapApiResponse(response);
  },

  exportAttendance: async (
    classId,
    { classSubjectId, startDate, endDate, studentId, status } = {}
  ) => {
    const response = await apiClient.get(`/teacher/classes/${classId}/attendance/export`, {
      params: {
        ...(classSubjectId ? { classSubjectId } : {}),
        startDate,
        endDate,
        ...(studentId ? { studentId } : {}),
        ...(status ? { status } : {}),
      },
      ...BINARY_REQUEST_CONFIG,
    });

    saveAxiosFile(response, `attendance-${classId}-${startDate}-${endDate}.xls`);
  },
};
